import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import "../css/delivery.scss";

function Delivery() {
  return (
    <div className="delivery">
      <Header />
      <div className="shopify-policy__container">
        <div className="shopify-policy__title">
          <h1>Shipping Policy</h1>
        </div>
        <div className="shopify-policy__body">
          <div className="rte prose max-w-none">
            <div className="free-shipping-banner">
              <div className="free-shipping-banner__icon">
                <svg viewBox="0 0 24 24">
                  <path d="M5 17H3a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11a2 2 0 0 1 2 2v3" />
                  <rect x="9" y="11" width="14" height="10" rx="1" />
                  <circle cx="12" cy="21" r="1" />
                  <circle cx="20" cy="21" r="1" />
                </svg>
              </div>
              <div className="free-shipping-banner__text">
                <h3>Free Shipping on All Orders!</h3>
                <p>
                  Enjoy complimentary shipping on all purchases with no minimum
                  order required.
                </p>
              </div>
            </div>

            <h2>Order Processing</h2>
            <ol>
              <li>
                Orders are processed Monday through Friday, excluding public
                holidays. Petoutlet will make every effort to deliver your order
                according to the estimated delivery timeframe.
              </li>
              <li>
                Orders placed before 2:00 PM HKT will be processed the same
                business day. Orders placed after 2:00 PM HKT will be processed
                the following business day.
              </li>
            </ol>

            <h2>Delivery Timeframes</h2>
            <div className="shipping-methods">
              <div className="shipping-method">
                <div className="shipping-method__icon">
                  <svg viewBox="0 0 24 24">
                    <rect x="1" y="3" width="15" height="13" />
                    <polygon points="16 8 20 8 23 11 23 16 16 16 16 8" />
                    <circle cx="5.5" cy="18.5" r="2.5" />
                    <circle cx="18.5" cy="18.5" r="2.5" />
                  </svg>
                </div>
                <div className="shipping-method__title">Standard Delivery</div>
                <div className="shipping-method__time">3-5 Business Days</div>
              </div>
              <div className="shipping-method">
                <div className="shipping-method__icon">
                  <svg viewBox="0 0 24 24">
                    <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
                  </svg>
                </div>
                <div className="shipping-method__title">Express Delivery</div>
                <div className="shipping-method__time">1-2 Business Days</div>
              </div>
              <div className="shipping-method">
                <div className="shipping-method__icon">
                  <svg viewBox="0 0 24 24">
                    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                    <circle cx="12" cy="10" r="3" />
                  </svg>
                </div>
                <div className="shipping-method__title">Same Day Delivery</div>
                <div className="shipping-method__time">
                  Order before 12:00 PM
                </div>
              </div>
            </div>

            <h2>Delivery Areas</h2>
            <ol>
              <li>We currently deliver to all addresses within Hong Kong.</li>
              <li>
                For delivery to other regions, please contact our customer
                service for assistance.
              </li>
              <li>
                We cannot deliver to P.O. boxes. Please provide a valid
                residential or commercial address.
              </li>
            </ol>

            <h2>Tracking Your Order</h2>
            <ol>
              <li>
                Once your order has shipped, a tracking number will be sent to
                your registered email address.
              </li>
              <li>
                You can track your package by clicking the link in the shipping
                confirmation email.
              </li>
              <li>
                For any delivery inquiries, please contact us at{" "}
                <a href="mailto:audit@petoutlet.work">audit@petoutlet.work</a>
              </li>
            </ol>

            <h2>Delivery Issues</h2>
            <div className="info-cards">
              <div className="info-card">
                <h4>Failed Delivery Attempts</h4>
                <p>
                  If delivery is attempted but no one is available to receive
                  the package, our delivery partner will leave a notification
                  card. You can reschedule delivery or pick up from the nearest
                  collection point.
                </p>
              </div>
              <div className="info-card">
                <h4>Incorrect Address</h4>
                <p>
                  Please ensure your delivery address is correct before
                  completing your order. Contact us immediately if you need to
                  update your address.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Delivery;
